import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M8.293 1.875h3.414c1.332 0 2.388 0 3.229.1.865.103 1.576.317 2.185.797.422.334.782.739 1.065 1.196.412.664.596 1.43.685 2.379.087.934.087 2.11.087 3.62v.066c0 1.51 0 2.686-.087 3.62-.09.949-.273 1.715-.685 2.379a4.6 4.6 0 0 1-1.065 1.196c-.608.48-1.32.694-2.185.797-.842.1-1.897.1-3.23.1H8.294c-1.332 0-2.387 0-3.229-.1-.865-.102-1.576-.317-2.185-.797a4.6 4.6 0 0 1-1.065-1.196c-.412-.664-.596-1.43-.685-2.379-.087-.934-.087-2.11-.087-3.62v-.066c0-1.509 0-2.686.087-3.62.09-.949.273-1.715.685-2.379A4.6 4.6 0 0 1 2.88 2.772c.609-.48 1.32-.694 2.185-.797.842-.1 1.897-.1 3.23-.1M5.212 3.217c-.744.087-1.2.254-1.56.537-.307.245-.57.54-.776.875-.267.427-.422.974-.503 1.834-.08.87-.081 1.988-.081 3.537 0 1.55 0 2.668.081 3.537.081.86.237 1.407.503 1.833.214.345.477.64.777.876.359.283.815.45 1.558.538.76.09 1.742.091 3.122.091h3.334c1.381 0 2.362 0 3.121-.092.744-.087 1.2-.254 1.56-.537.299-.236.562-.531.776-.875.267-.427.422-.973.502-1.834.081-.87.082-1.988.082-3.537 0-1.55 0-2.668-.082-3.537-.08-.86-.236-1.407-.502-1.833a3.4 3.4 0 0 0-.776-.876c-.36-.283-.816-.45-1.559-.538-.76-.09-1.742-.091-3.122-.091H8.333c-1.381 0-2.362 0-3.121.092",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M7.292 17.5v-15h1.25v15zM3.542 5.833a.625.625 0 0 1 .625-.625H5a.625.625 0 0 1 0 1.25h-.833a.625.625 0 0 1-.625-.625m0 2.5a.625.625 0 0 1 .625-.625H5a.625.625 0 0 1 0 1.25h-.833a.625.625 0 0 1-.625-.625",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }